// extracted by mini-css-extract-plugin
module.exports = {"myProfile__container":"style_myProfile__container__28VFT","myProfile__input-container":"style_myProfile__input-container__2zc30"};